import { TagProps } from 'antd';

export const STATUS_MAP: Record<
  string,
  { text: string; color: TagProps['color'] }
> = {
  active: { text: 'Ativo', color: 'green' },
  approved: { text: 'Aprovado', color: 'green' },
  pending: { text: 'Pendente', color: 'orange' },
  rejected: { text: 'Rejeitado', color: 'red' },
  waiting: { text: 'Aguardando', color: 'yellow' },
  archived: { text: 'Arquivado', color: 'gray' },
  redacted: { text: 'Redigido', color: 'purple' },
  censored: { text: 'Censurado', color: 'orange' },
  closed: { text: 'Encerrada', color: 'gray' },
  unknown: { text: 'Desconhecida', color: 'gray' },
  started: { text: 'Iniciada', color: 'blue' },
  evaluation_started: { text: 'Em correção', color: 'yellow' },
  pending_evaluation: { text: 'Aguardando correção', color: 'yellow' },
  evaluated: { text: 'Corrigida', color: 'green' },
  passed: { text: 'Aprovada', color: 'green' },
  failed: { text: 'Reprovada', color: 'red' },
  scored: { text: 'Nota calculada', color: 'green' },
  initial: { text: 'Não Recebido', color: 'blue' },
  paid: { text: 'Pago', color: 'green' },
  cancelled: { text: 'Cancelado', color: 'yellow' },
  due: { text: 'Vencido', color: 'red' },
  submitted: { text: 'Submetido', color: 'blue' }
};
